import React, { useCallback, useMemo, useState } from 'react';
import { AutocompleteDropdown, Box, OptionKey, Text, useDebounce } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import useGetMatchedEmployeesQuery from '@/modules/employer/components/Lockbox/queries/useGetMatchedEmployees.query';

const SelectEmployee = () => {
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchString = useDebounce(searchValue, 500);
  const { editableLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();
  const { foundEmployees, isLoading } = useGetMatchedEmployeesQuery({ searchValue: debouncedSearchString });

  const accountOptions = useMemo(() => foundEmployees?.map((employee) => ({
    key: toString(employee?.employeeId),
    value: toString(employee?.employeeId),
    title: employee?.employeeName,
    isNodeInTheEnd: true,
    maxItemWidth: 'fit-content',
    ...employee?.ssn ? {
      node: (
        <Text color="textSecondary" style={{ whiteSpace: 'pre' }}>{' '}({employee?.ssn})</Text>
      )
    } : {},
  })), [foundEmployees]);
  
  const handleSearchEmployee = useCallback((value: string) => {
    setSearchValue(value);
  }, []);

  const handleChangeEmployeeId = useCallback((employeeId: OptionKey) => {
    setEditableLockbox({
      employeeId: employeeId as string,
    });
  }, [setEditableLockbox]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.EMPLOYEE_REQUIRED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  return (
    <Box>
      <Text color="textSecondary">Select Employee</Text>
      <Box margin={{ top: 'spacing12' }}>
        <AutocompleteDropdown
          testId="select-employee"
          name="select-employee"
          placeholder="Search for Employee by name or SSN"
          disableFiltering
          value={editableLockbox?.employeeId}
          onSearch={handleSearchEmployee}
          onChange={handleChangeEmployeeId}
          options={accountOptions}
          isLoading={isLoading}
          errorText={errorType ? lockboxValidationErrorTitle?.[errorType] : undefined}
        />
      </Box>
    </Box>
  );
};

export default SelectEmployee;
